import DoubleSidebar from '@seller-hermes/features/ui-v2/double-sidebar';
import { Loader2 } from 'lucide-react';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@seller-hermes/app/app-sidebar';
import { DemoFridayCard } from '@seller-hermes/features/announcements/demo-friday-card.component';

export const LoggedPageLayout = React.memo(() => {
  return (
    <DoubleSidebar.Provider
      defaultWidth="28rem"
      defaultWidthRight="40rem"
      defaultOpenRight={false}
      className="[--header-height:4.5rem]"
    >
      <AppSidebar />
      <DoubleSidebar.Inset className="h-[calc(100vh)] min-w-0">
        <React.Suspense
          fallback={
            <div className="flex h-full w-full items-center justify-center">
              <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
            </div>
          }
        >
          <Outlet />
        </React.Suspense>
        <DemoFridayCard />
      </DoubleSidebar.Inset>
    </DoubleSidebar.Provider>
  );
});
